import { useState } from "react";
import FsLightbox from "fslightbox-react";

// Style
import style from "./module-video.module.scss";

// Components
import Image from "next/image";
import IconFA from "@/components/icon-fa/icon-fa";

export default function ModuleVideo({ video }) {
  if (video === null) {
    return;
  }

  // -- Variables
  const videoPath = video.videoFields;
  const videoType = videoPath.videoType;

  const videoOptions = videoPath.videoOptions;

  // File Vars
  const fileOptions = videoPath.fileOptions;
  var fileOptionsFormatted = {};
  fileOptions?.forEach(function (item) {
    fileOptionsFormatted[item] = true;
  });

  // Lightbox
  const isLightbox = videoOptions?.includes("lightbox") ?? false;
  const [toggler, setToggler] = useState(false);

  let lightboxSources = [];
  switch (videoType) {
    case "file":
      lightboxSources.push(videoPath.videoFile?.node.mediaItemUrl);
      break;
    case "embed":
      lightboxSources.push(videoPath.videoEmbed);
      break;
  }

  return (
    <div className="moduleVideo">
      <div className={style.moduleVideoContainer}>
        {/* Video Covers - Image & Looping Video */}
        {(videoOptions?.includes("cover_loop") ||
          videoOptions?.includes("image_cover")) && (
          <div
            className={`${style.moduleVideoCover} moduleVideoCover`}
            onClick={(e) => {
              // Lightbox on Click
              if (isLightbox) {
                setToggler(!toggler);
                // Hide Cover on Click
              } else {
                var coverObject = e.target.closest(".moduleVideoCover");
                coverObject.setAttribute("hide", true);
                var videoObject = coverObject.nextElementSibling;
                if (
                  videoObject &&
                  videoObject.classList.contains("embedWrapper")
                ) {
                  var videoIFrame = videoObject.querySelector("iframe");
                  videoIFrame.setAttribute(
                    "src",
                    videoIFrame.getAttribute("src") + "&autoplay=1&muted=1"
                  );
                }
              }
            }}
          >
            {/* Video Icon */}
            {videoOptions?.includes("play_icon") && videoPath?.playIcon ? (
              <div dangerouslySetInnerHTML={{ __html: videoPath.playIcon }} />
            ) : (
              <IconFA name="faCirclePlay" color="var(--color--button)" />
            )}
            {/* Image */}
            {videoOptions?.includes("image_cover") &&
              videoPath.imageCover?.node["sourceUrl"] && (
                <div className={style.moduleImageObject}>
                  <Image
                    src={videoPath.imageCover?.node["sourceUrl"]}
                    alt={videoPath.imageCover?.node["altText"] ?? ""}
                    width={1400}
                    height={1400}
                  />
                </div>
              )}
            {/* Looping Video */}
            {videoOptions?.includes("cover_loop") &&
              videoPath.loopingCover?.node.mediaItemUrl && (
                <div className={style.moduleVideoObject}>
                  <video
                    loop
                    muted
                    autoPlay
                    playsInline
                    src={videoPath.loopingCover?.node.mediaItemUrl}
                  ></video>
                </div>
              )}
          </div>
        )}

        {/* Lightbox OR Not */}
        {isLightbox && (
          <div
            className={`lightbox ${style.moduleVideoObject}`}
            lightbox="true"
          >
            <FsLightbox
              toggler={toggler}
              sources={lightboxSources}
              customAttributes={[
                {
                  autoPlay: true,
                  playsInline: true,
                },
              ]}
              loadOnlyCurrentSource={true}
              exitFullscreenOnClose={true}
              onOpen={(e) => {
                e.elements.container.current
                  .closest(".container")
                  ?.setAttribute("style", "z-index: 2;");
              }}
              onClose={(e) => {
                e.elements.container.current
                  .closest(".container")
                  ?.setAttribute("style", "");
              }}
            />
          </div>
        )}

        {/* Video File */}
        {videoType === "file" && !isLightbox && (
          <div className={style.moduleVideoObject}>
            <video
              {...fileOptionsFormatted}
              muted={fileOptions.includes("autoPlay") && true}
              playsInline={""}
              poster={videoPath.imageCover?.node.sourceUrl}
              src={videoPath.videoFile?.node.mediaItemUrl}
            />
          </div>
        )}

        {/* Video Embed */}
        {videoType === "embed" && !isLightbox && (
          <div
            className={`${style.moduleVideoObject} embedWrapper`}
            dangerouslySetInnerHTML={{ __html: videoPath.videoEmbed }}
          />
        )}

        {/* Video SVG */}
        {videoType === "svg" && (
          <div
            className={`${style.moduleVideoSVG}`}
            dangerouslySetInnerHTML={{ __html: videoPath.animatedSvg }}
          />
        )}
      </div>
    </div>
  );
}
